<div class="section-nav-bar" *ngIf="tabs && tabs.length > 0">
  <nav mat-tab-nav-bar>
    <a mat-tab-link *ngFor="let tab of tabs" (click)="onClickTab(tab)" [active]="activeTab === tab">
      {{ tab.label }}
    </a>
  </nav>
</div>
